/* eslint-disable no-unused-vars */

import { trackAmplitude } from 'src/lib/analytics'

const eventClicked = (props) => {
  trackAmplitude(
    'View Event',
    { ref: props.page, section: props.sectionId, listing_slug: props.slug },
    props.viewer,
  )
}

const hostClicked = (props) => {
  trackAmplitude(
    'View Host Profile',
    { ref: props.page, section: props.sectionId, host_name: props.hostName },
    props.viewer,
  )
}

export {
  eventClicked,
  hostClicked,
}
